/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
import Feature from 'ol/Feature';
import Geometry from 'ol/geom/Geometry';
import { Projection } from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import VectorImageLayer from 'ol/layer/VectorImage';
import TileSource from 'ol/source/Tile';
import type VectorSource from 'ol/source/Vector';
import ImageTile from 'ol/ImageTile';
import Map from 'ol/Map';

export function isOpenlayersFeature(obj: unknown): obj is Feature<Geometry> {
  return obj instanceof Feature;
}

export function isOpenlayersGeometry(obj: unknown): obj is Geometry {
  return obj instanceof Geometry;
}

export function isOpenlayersProjection(obj: unknown): obj is Projection {
  return obj instanceof Projection;
}

export function isTileLayer(obj: unknown): obj is TileLayer<TileSource> {
  return obj instanceof TileLayer;
}

export function isVectorImageLayer(obj: unknown): obj is VectorImageLayer<VectorSource> {
  return obj instanceof VectorImageLayer;
}

export function isImageTile(obj: unknown): obj is ImageTile {
  return obj instanceof ImageTile;
}

export function isOpenlayersMap(obj: unknown): obj is Map {
  return obj instanceof Map;
}

export function isTileSource(obj: unknown): obj is TileSource {
  return obj instanceof TileSource;
}
